var statefulIcons = {
	"content-and-activities-activities-alt-image": {
	"default": "content-and-activities-activities-alt-image-default",
	hover: "content-and-activities-activities-alt-image-hover"
},
	"content-and-activities-collaborate-board-add-image": {
	"default": "content-and-activities-collaborate-board-add-image-default",
	disabled: "content-and-activities-collaborate-board-add-image-disabled",
	hover: "content-and-activities-collaborate-board-add-image-hover"
},
	"content-and-activities-collaborate-board-delete": {
	"default": "content-and-activities-collaborate-board-delete-default"
},
	"content-and-activities-collaborate-board-pending-post": {
	"default": "content-and-activities-collaborate-board-pending-post-default",
	hover: "content-and-activities-collaborate-board-pending-post-hover"
},
	"content-and-activities-collaborate-board-restore": {
	"default": "content-and-activities-collaborate-board-restore-default"
},
	"content-and-activities-collaborate-board-time": {
	"default": "content-and-activities-collaborate-board-time-default"
},
	"content-and-activities-drawit-add-image": {
	"default": "content-and-activities-drawit-add-image-default",
	hover: "content-and-activities-drawit-add-image-hover"
},
	"content-and-activities-drawit-crayon": {
	"default": "content-and-activities-drawit-crayon-default",
	hover: "content-and-activities-drawit-crayon-hover"
},
	"content-and-activities-drawit-delete": {
	"default": "content-and-activities-drawit-delete-default",
	hover: "content-and-activities-drawit-delete-hover"
},
	"content-and-activities-drawit-erase": {
	"default": "content-and-activities-drawit-erase-default",
	hover: "content-and-activities-drawit-erase-hover"
},
	"content-and-activities-drawit-locked-small": {
	"default": "content-and-activities-drawit-locked-small-default"
},
	"content-and-activities-drawit-locked": {
	"default": "content-and-activities-drawit-locked-default",
	hover: "content-and-activities-drawit-locked-hover"
},
	"content-and-activities-drawit-marker": {
	"default": "content-and-activities-drawit-marker-default",
	hover: "content-and-activities-drawit-marker-hover"
},
	"content-and-activities-drawit-redo": {
	"default": "content-and-activities-drawit-redo-default",
	disabled: "content-and-activities-drawit-redo-disabled",
	hover: "content-and-activities-drawit-redo-hover"
},
	"content-and-activities-drawit-select": {
	"default": "content-and-activities-drawit-select-default",
	hover: "content-and-activities-drawit-select-hover"
},
	"content-and-activities-drawit-text": {
	"default": "content-and-activities-drawit-text-default",
	hover: "content-and-activities-drawit-text-hover"
},
	"content-and-activities-drawit-undo": {
	"default": "content-and-activities-drawit-undo-default",
	disabled: "content-and-activities-drawit-undo-disabled",
	hover: "content-and-activities-drawit-undo-hover"
},
	"content-and-activities-drawit-unlocked": {
	"default": "content-and-activities-drawit-unlocked-default",
	hover: "content-and-activities-drawit-unlocked-hover"
},
	"content-and-activities-misc-check": {
	"default": "content-and-activities-misc-check-default",
	hover: "content-and-activities-misc-check-hover",
	selected: "content-and-activities-misc-check-selected"
},
	"content-and-activities-misc-duplicate": {
	"default": "content-and-activities-misc-duplicate-default",
	hover: "content-and-activities-misc-duplicate-hover"
},
	"content-and-activities-misc-math-function": {
	"default": "content-and-activities-misc-math-function-default",
	disabled: "content-and-activities-misc-math-function-disabled",
	hover: "content-and-activities-misc-math-function-hover"
},
	"content-and-activities-misc-text": {
	"default": "content-and-activities-misc-text-default",
	selected: "content-and-activities-misc-text-selected"
},
	"in-session-active-sessions": {
	"default": "in-session-active-sessions-default"
},
	"content-and-activities-video-audio-controls-blue": {
	"default": "content-and-activities-video-audio-controls-default-blue-default"
},
	"content-and-activities-video-audio-controls-mute-white": {
	"default": "content-and-activities-video-audio-controls-mute-white-default"
},
	"content-and-activities-video-audio-controls-pause-blue": {
	"default": "content-and-activities-video-audio-controls-pause-blue-default"
},
	"content-and-activities-video-audio-controls-pause-white": {
	"default": "content-and-activities-video-audio-controls-pause-white-default"
},
	"content-and-activities-video-audio-controls-play-blue": {
	"default": "content-and-activities-video-audio-controls-play-blue-default"
},
	"content-and-activities-video-audio-controls-play-white": {
	"default": "content-and-activities-video-audio-controls-play-white-default"
},
	"content-and-activities-video-audio-controls-setting-white": {
	"default": "content-and-activities-video-audio-controls-setting-white-default"
},
	"content-and-activities-video-audio-controls-stop-red": {
	"default": "content-and-activities-video-audio-controls-stop-red-default"
},
	"content-and-activities-video-audio-controls-stop-white": {
	"default": "content-and-activities-video-audio-controls-stop-white-default"
},
	"content-and-activities-video-audio-controls-timer-white": {
	"default": "content-and-activities-video-audio-controls-timer-white-default"
},
	"content-and-activities-video-audio-controls-volume-white": {
	"default": "content-and-activities-video-audio-controls-volume-white-default",
	disabled: "in-session-active-sessions-disabled",
	hover: "in-session-active-sessions-hover"
},
	"content-creation-add-quick-slide-small": {
	"default": "content-creation-add-quick-slide-small-default",
	disabled: "content-creation-add-quick-slide-small-disabled"
},
	"content-creation-add-quiz-small": {
	"default": "content-creation-add-quiz-small-default",
	disabled: "content-creation-add-quiz-small-disabled"
},
	"content-creation-file-upload-slide-small": {
	"default": "content-creation-file-upload-small-default",
	disabled: "content-creation-file-upload-small-disabled"
},
	"in-session-expand-to-full-screen": {
	"default": "in-session-expand-to-full-screen-default",
	hover: "in-session-expand-to-full-screen-hover"
},
	"in-session-rejoin-lesson": {
	"default": "in-session-rejoin-lesson-default"
},
	"left-navigation-add": {
	"default": "left-navigation-add-default"
},
	"left-navigation-folder": {
	"default": "left-navigation-folder-default"
},
	"main-navbar-district-library": {
	"default": "main-navbar-district-library-default",
	disabled: "main-navbar-district-library-disabled",
	hover: "main-navbar-district-library-hover"
},
	"main-navbar-public-library": {
	"default": "main-navbar-public-library-default",
	disabled: "main-navbar-public-library-disabled",
	hover: "main-navbar-public-library-hover"
},
	"main-navbar-school-library": {
	"default": "main-navbar-school-library-default",
	disabled: "main-navbar-school-library-disabled",
	hover: "main-navbar-school-library-hover"
},
	"main-navbar-search": {
	"default": "main-navbar-search-default",
	disabled: "main-navbar-search-disabled",
	hover: "main-navbar-search-hover"
},
	"my-lessons-add-to-folder-or-library": {
	"default": "my-lessons-add-to-folder-or-library-default"
},
	"my-lessons-delete-lesson": {
	"default": "my-lessons-delete-lesson-default",
	hover: "my-lessons-delete-lesson-hover"
},
	"my-lessons-drag-dark": {
	"default": "my-lessons-drag-dark-default",
	disabled: "my-lessons-drag-dark-disabled",
	hover: "my-lessons-drag-dark-hover"
},
	"my-lessons-drag-light": {
	"default": "my-lessons-drag-light-default"
},
	"my-lessons-duplicate-lesson": {
	"default": "my-lessons-duplicate-lesson-default",
	hover: "my-lessons-duplicate-lesson-hover"
},
	"my-lessons-edit-lesson": {
	"default": "my-lessons-edit-lesson-default",
	hover: "my-lessons-edit-lesson-hover",
	disabled: "my-lessons-folder-big-add-disabled"
},
	"my-lessons-edit-lesson-xs": {
	"default": "my-lesson-gallery-settings-lesson-details-xs-default",
	hover: "my-lesson-gallery-settings-lesson-details-xs-hover"
},
	"my-lessons-folder-big-delete": {
	"default": "my-lessons-folder-big-delete-default"
},
	"my-lessons-folder-color": {
	"default": "my-lessons-folder-color-default",
	disabled: "my-lessons-folder-color-disabled",
	hover: "my-lessons-folder-color-hover"
},
	"my-lessons-folder-small": {
	"default": "my-lessons-folder-small-default-default"
},
	"my-lessons-meatball-small": {
	"default": "my-lessons-meatball-small-default",
	hover: "my-lessons-meatball-small-hover"
},
	"my-lessons-meatball-large": {
	"default": "my-lessons-meatball-large-default",
	hover: "my-lessons-meatball-large-hover"
},
	"my-lessons-folder-kebab-large": {
	"default": "my-lessons-folder-kebab-large-default",
	hover: "my-lessons-folder-kebab-large-hover"
},
	"my-lessons-meatball-white-large": {
	"default": "my-lessons-meatball-white-large-default",
	hover: "my-lessons-meatball-white-large-hover"
},
	"my-lessons-meatball-white-medium": {
	"default": "my-lessons-meatball-white-medium-default",
	hover: "my-lessons-meatball-medium-hover"
},
	"my-lessons-menu-dotted-big": {
	"default": "my-lessons-menu-dotted-big-default",
	hover: "my-lessons-menu-dotted-big-hover"
},
	"my-lessons-menu-gray-dotted-small": {
	"default": "my-lessons-menu-gray-dotted-small-default",
	hover: "my-lessons-menu-gray-dotted-small-hover",
	selected: "my-lessons-menu-gray-dotted-small-selected"
},
	"my-lessons-menu-dotted-small": {
	"default": "my-lessons-menu-dotted-small-default",
	disabled: "my-lessons-menu-dotted-small-disabled",
	hover: "my-lessons-menu-dotted-small-hover"
},
	"my-lessons-menu-dotted-gray-xs": {
	"default": "my-lessons-menu-dotted-gray-xs-default",
	hover: "my-lessons-menu-dotted-gray-xs-hover",
	selected: "my-lessons-menu-dotted-gray-xs-selected"
},
	"my-lessons-share-lesson": {
	"default": "my-lessons-share-lesson-default",
	disabled: "my-lessons-share-lesson-disabled",
	hover: "my-lessons-share-lesson-hover"
},
	"my-lessons-showhide-hide": {
	"default": "my-lessons-showhide-hide-default",
	disabled: "my-lessons-showhide-hide-disabled",
	hover: "my-lessons-showhide-hide-hover"
},
	"my-lessons-showhide-show": {
	"default": "my-lessons-showhide-show-default",
	disabled: "my-lessons-showhide-show-disabled",
	hover: "my-lessons-showhide-show-hover"
},
	"my-lessons-preview": {
	"default": "my-lessons-preview-default",
	hover: "my-lessons-preview-hover"
},
	"my-lessons-add-folder": {
	"default": "my-lessons-add-folder-default",
	hover: "my-lessons-add-folder-hover"
},
	"my-lessons-delete-white-xs": {
	"default": "my-lessons-delete-white-xs-default",
	hover: "my-lessons-delete-white-xs-hover"
},
	"my-lessons-delete-xs": {
	"default": "my-lessons-delete-xs-default",
	hover: "my-lessons-delete-xs-hover"
},
	"my-lessons-edit-white-xs": {
	"default": "my-lessons-edit-white-xs-default",
	hover: "my-lessons-edit-white-xs-hover"
},
	"my-lessons-edit-xs": {
	"default": "my-lessons-visibility-xs-default",
	hover: "my-lessons-visibility-xs-hover"
},
	"my-lessons-visibility-white-xs": {
	"default": "my-lessons-visibility-white-xs-default",
	hover: "my-lessons-visibility-white-xs-hover"
},
	"my-lessons-visibility-xs": {
	"default": "my-lessons-visibility-xs-default",
	hover: "my-lessons-visibility-xs-hover"
},
	"my-lesson-gallery-copy-slides-big": {
	"default": "my-lesson-gallery-copy-slides-big-default"
},
	"my-lesson-gallery-copy-slides-small": {
	"default": "my-lesson-gallery-copy-slides-small-default",
	disabled: "my-lesson-gallery-copy-slides-small-disabled",
	hover: "my-lesson-gallery-copy-slides-small-hover"
},
	"my-lesson-gallery-delete": {
	"default": "my-lesson-gallery-delete-default",
	disabled: "my-lesson-gallery-delete-disabled",
	hover: "my-lesson-gallery-delete-hover"
},
	"my-lesson-gallery-delete-red-hover": {
	"default": "my-lesson-gallery-delete-red-hover-default",
	hover: "my-lesson-gallery-delete-red-hover-hover"
},
	"my-lesson-gallery-duplicate-question": {
	"default": "my-lesson-gallery-duplicate-question-default",
	disabled: "my-lesson-gallery-duplicate-question-disabled",
	hover: "my-lesson-gallery-duplicate-question-hover"
},
	"my-lesson-gallery-duplicate-slide-lesson": {
	"default": "my-lesson-gallery-duplicate-slide-lesson-default",
	hover: "my-lesson-gallery-duplicate-slide-lesson-hover"
},
	"my-lesson-gallery-paste-big": {
	"default": "my-lesson-gallery-paste-big-default"
},
	"my-lesson-gallery-paste-small": {
	"default": "my-lesson-gallery-paste-small-default",
	disabled: "my-lesson-gallery-paste-small-disabled",
	hover: "my-lesson-gallery-paste-small-hover"
},
	"my-lesson-gallery-settings-lesson-details": {
	"default": "my-lesson-gallery-settings-lesson-details-default",
	disabled: "my-lesson-gallery-settings-lesson-details-disabled",
	hover: "my-lesson-gallery-settings-lesson-details-hover"
},
	"my-lesson-gallery-settings-lesson-details-gray-hover": {
	"default": "my-lesson-gallery-settings-lesson-details-gray-hover-default",
	hover: "my-lesson-gallery-settings-lesson-details-gray-hover-hover"
},
	"reports-chevron-backward-small": {
	"default": "reports-chevron-backward-small-default",
	disabled: "reports-chevron-backward-small-disabled"
},
	"reports-chevron-forward-small": {
	"default": "reports-chevron-forward-small-default",
	disabled: "reports-chevron-forward-small-disabled"
},
	"reports-edit-pencil": {
	"default": "reports-edit-pencil-default",
	hover: "reports-edit-pencil-hover"
},
	"reports-post-session-reports": {
	"default": "reports-post-session-reports-default",
	hover: "reports-post-session-reports-hover"
},
	"search-neutral-xs": {
	"default": "search-neutral-xs-default",
	hover: "search-neutral-xs-hover"
},
	"slide-editor-audio": {
	"default": "slide-editor-audio-default",
	hover: "slide-editor-audio-hover",
	selected: "slide-editor-audio-selected",
	disabled: "slide-editor-audio-disabled"
},
	"slide-editor-background": {
	"default": "slide-editor-background-default",
	hover: "slide-editor-background-hover",
	selected: "slide-editor-background-selected",
	disabled: "slide-editor-background-disabled"
},
	"slide-editor-border-color": {
	"default": "slide-editor-border-color-default",
	hover: "slide-editor-border-color-hover",
	selected: "slide-editor-border-color-selected",
	disabled: "slide-editor-border-color-disabled"
},
	"slide-editor-bring-to-front": {
	"default": "slide-editor-bring-to-front-default",
	hover: "slide-editor-bring-to-front-hover",
	selected: "slide-editor-bring-to-front-selected",
	disabled: "slide-editor-bring-to-front-disabled"
},
	"slide-editor-color": {
	"default": "slide-editor-color-default",
	hover: "slide-editor-color-hover",
	selected: "slide-editor-color-selected",
	disabled: "slide-editor-color-disabled"
},
	"slide-editor-copy": {
	"default": "slide-editor-copy-default",
	hover: "slide-editor-copy-hover",
	selected: "slide-editor-copy-selected",
	disabled: "slide-editor-copy-disabled"
},
	"slide-editor-dash": {
	"default": "slide-editor-dash-default",
	hover: "slide-editor-dash-hover",
	selected: "slide-editor-dash-selected",
	disabled: "slide-editor-dash-disabled"
},
	"slide-editor-delete": {
	"default": "slide-editor-delete-default",
	hover: "slide-editor-delete-hover",
	selected: "slide-editor-delete-selected",
	disabled: "slide-editor-delete-disabled"
},
	"slide-editor-eraser": {
	"default": "slide-editor-eraser-default",
	hover: "slide-editor-eraser-hover",
	selected: "slide-editor-eraser-selected",
	disabled: "slide-editor-eraser-disabled"
},
	"slide-editor-gif": {
	"default": "slide-editor-gif-default",
	hover: "slide-editor-gif-hover",
	selected: "slide-editor-gif-selected",
	disabled: "slide-editor-gif-disabled"
},
	"slide-editor-image": {
	"default": "slide-editor-image-default",
	hover: "slide-editor-image-hover",
	selected: "slide-editor-image-selected",
	disabled: "slide-editor-image-disabled"
},
	"slide-editor-link": {
	"default": "slide-editor-link-default",
	hover: "slide-editor-link-hover",
	selected: "slide-editor-link-selected",
	disabled: "slide-editor-link-disabled"
},
	"slide-editor-marker": {
	"default": "slide-editor-marker-default",
	hover: "slide-editor-marker-hover",
	selected: "slide-editor-marker-selected",
	disabled: "slide-editor-marker-disabled"
},
	"slide-editor-paste": {
	"default": "slide-editor-paste-default",
	hover: "slide-editor-paste-hover",
	selected: "slide-editor-paste-selected",
	disabled: "slide-editor-paste-disabled"
},
	"slide-editor-record": {
	"default": "slide-editor-record-default",
	hover: "slide-editor-record-hover",
	selected: "slide-editor-record-selected",
	disabled: "slide-editor-record-disabled"
},
	"slide-editor-redo": {
	"default": "slide-editor-redo-default",
	hover: "slide-editor-redo-hover",
	selected: "slide-editor-redo-selected",
	disabled: "slide-editor-redo-disabled"
},
	"slide-editor-select": {
	"default": "slide-editor-select-default",
	hover: "slide-editor-select-hover",
	selected: "slide-editor-select-selected",
	disabled: "slide-editor-select-disabled"
},
	"slide-editor-send-to-back": {
	"default": "slide-editor-send-to-back-default",
	hover: "slide-editor-send-to-back-hover",
	selected: "slide-editor-send-to-back-selected",
	disabled: "slide-editor-send-to-back-disabled"
},
	"slide-editor-shapes": {
	"default": "slide-editor-shapes-default",
	hover: "slide-editor-shapes-hover",
	selected: "slide-editor-shapes-selected",
	disabled: "slide-editor-shapes-disabled"
},
	"slide-editor-text": {
	"default": "slide-editor-text-default",
	hover: "slide-editor-text-hover",
	selected: "slide-editor-text-selected",
	disabled: "slide-editor-text-disabled"
},
	"slide-editor-undo": {
	"default": "slide-editor-undo-default",
	hover: "slide-editor-undo-hover",
	selected: "slide-editor-undo-selected",
	disabled: "slide-editor-undo-disabled"
},
	"slide-editor-upload-audio-file": {
	"default": "slide-editor-upload-audio-file-default",
	hover: "slide-editor-upload-audio-file-hover",
	selected: "slide-editor-upload-audio-file-selected",
	disabled: "slide-editor-upload-audio-file-disabled"
},
	"slide-editor-video": {
	"default": "slide-editor-video-default",
	hover: "slide-editor-video-hover",
	selected: "slide-editor-video-selected",
	disabled: "slide-editor-video-disabled"
},
	"slide-editor-weight": {
	"default": "slide-editor-weight-default",
	hover: "slide-editor-weight-hover",
	selected: "slide-editor-weight-selected",
	disabled: "slide-editor-weight-disabled"
},
	"slide-editor-zoom": {
	"default": "slide-editor-zoom-default",
	hover: "slide-editor-zoom-hover",
	selected: "slide-editor-zoom-selected",
	disabled: "slide-editor-zoom-disabled"
},
	"system-ui-check": {
	"default": "system-ui-check-default",
	hover: "system-ui-check-hover",
	selected: "system-ui-check-selected",
	disabled: "system-ui-check-disabled"
},
	"system-ui-filter": {
	"default": "system-ui-filter-default",
	hover: "system-ui-filter-hover",
	selected: "system-ui-filter-selected"
},
	"system-ui-chevron-left-small": {
	"default": "system-ui-chevron-left-small-default",
	disabled: "system-ui-chevron-left-small-disabled"
},
	"system-ui-chevron-right-small": {
	"default": "system-ui-chevron-right-small-default",
	disabled: "system-ui-chevron-right-small-disabled"
},
	"system-ui-close-preview": {
	"default": "system-ui-close-preview-default",
	hover: "system-ui-close-preview-hover"
},
	"system-ui-collapse-expand-all-down": {
	"default": "system-ui-collapse-expand-all-down-default",
	hover: "system-ui-collapse-expand-all-down-hover"
},
	"system-ui-collapse-expand-all-up": {
	"default": "system-ui-collapse-expand-all-up-default",
	hover: "system-ui-collapse-expand-all-up-hover"
},
	"system-ui-edit": {
	"default": "system-ui-edit-default",
	hover: "system-ui-edit-hover"
},
	"system-ui-full-screen-icon-label-dark": {
	"default": "system-ui-full-screen-icon-label-dark-default",
	disabled: "system-ui-full-screen-icon-label-dark-disabled",
	hover: "system-ui-full-screen-icon-label-dark-hover"
},
	"system-ui-full-screen-icon-label-light": {
	"default": "system-ui-full-screen-icon-label-light-default",
	disabled: "system-ui-full-screen-icon-label-light-disabled",
	hover: "system-ui-full-screen-icon-label-light-hover"
},
	"system-ui-full-screen-icon-light": {
	"default": "system-ui-full-screen-icon-light-default",
	disabled: "system-ui-full-screen-icon-light-disabled",
	hover: "system-ui-full-screen-icon-light-hover"
},
	"system-ui-plus-light-shadow": {
	"default": "system-ui-plus-light-shadow-default",
	hover: "system-ui-plus-light-shadow-hover"
},
	"system-ui-right-arrow-medium": {
	"default": "system-ui-right-arrow-medium-default",
	hover: "system-ui-right-arrow-medium-hover"
},
	"system-ui-join-lesson-button": {
	"default": "system-ui-join-lesson-button-default",
	hover: "system-ui-join-lesson-button-hover"
},
	"system-ui-send-blue": {
	"default": "system-ui-send-blue-default"
},
	"system-ui-send-dark": {
	"default": "system-ui-send-dark-default",
	hover: "system-ui-send-dark-hover",
	disabled: "system-ui-send-dark-disabled"
},
	"system-ui-send-light": {
	"default": "system-ui-send-light-default",
	hover: "system-ui-send-light-hover"
}
};

export { statefulIcons as default };
//# sourceMappingURL=statefulIconMapping.json.js.map
